import filter from './filter';
export default function skip(count, stream) {
    if (count <= 0) {
        return stream;
    }
    return filter(
    // tslint:disable-next-line:ter-prefer-arrow-callback
    function skipFilter(value, index) {
        return index >= count;
    }, stream);
}
//# sourceMappingURL=skip.js.map